const navigation = ["HOME", "OVERVIEW", "PROJECTS", "EXPERIENCE", "CONTACT"];

export { navigation }